import { Form, Input, Modal, ModalProps, Button, Spin } from 'components/common'

export interface UndoCancelModalProps extends Omit<ModalProps, 'onOk'> {
  onOk: (reason: string) => Promise<void>
  onClose: (value: boolean) => void
  undoCancelReason: string
  setUndoCancelReason: React.Dispatch<React.SetStateAction<string>>
  loading: boolean
}

interface CancelForm {
  cancelReason: string
}

export const UndoCancelModal = ({
  visible,
  onClose,
  onOk,
  undoCancelReason,
  setUndoCancelReason,
  loading,
}: UndoCancelModalProps) => {
  const [form] = Form.useForm<CancelForm>()
  const onSubmit = async (values: CancelForm) => {
    try {
      await onOk(values.cancelReason)
      onClose(false)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Modal
      title={'予約のキャンセルを取り消す'}
      visible={visible}
      onCancel={() => onClose(false)}
      onOk={() => {
        form
          .validateFields()
          .then((values) => onSubmit(values))
          .catch((error) => console.error(error))
      }}
      footer={
        <div className="flex justify-end space-x-4">
          <Button onClick={() => onClose(false)} disabled={loading}>
            閉じる
          </Button>
          <Button
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then((values) => onSubmit(values))
                .catch((error) => console.error(error))
            }}
            disabled={loading}
          >
            実行
          </Button>
        </div>
      }
    >
      <Spin spinning={loading} tip="キャンセルの取り消しを実行中...">
        <Form form={form} name="form_in_modal">
          <Form.Item
            name={'cancelReason'}
            label="取り消し理由"
            rules={[
              { required: true, message: '取り消し理由を入力してください' },
            ]}
          >
            <Input
              value={undoCancelReason}
              onChange={(event) => setUndoCancelReason(event.target.value)}
              placeholder="取り消し理由を入力してください"
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}
